import React from 'react';
import { Card } from '../../../components/ui/card';
import { CheckCircle, Clock, AlertTriangle } from 'lucide-react';

interface Stats {
  pending: number;
  approved: number;
  inProgress: number;
  completed: number;
}

interface RecruitmentStatsCardsProps {
  stats: Stats;
}

export default function RecruitmentStatsCards({ stats }: RecruitmentStatsCardsProps) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <Card className="border-l-4 border-l-amber-500">
        <div className="p-4 flex items-center h-full min-h-[100px]">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-sm text-gray-500">Menunggu</p>
              <p className="text-2xl font-bold">{stats.pending}</p>
            </div>
            <AlertTriangle className="w-8 h-8 text-amber-500" />
          </div>
        </div>
      </Card>
      <Card className="border-l-4 border-l-green-500">
        <div className="p-4 flex items-center h-full min-h-[100px]">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-sm text-gray-500">Disetujui</p>
              <p className="text-2xl font-bold">{stats.approved}</p>
            </div>
            <CheckCircle className="w-8 h-8 text-green-500" />
          </div>
        </div>
      </Card>
      <Card className="border-l-4 border-l-blue-500">
        <div className="p-4 flex items-center h-full min-h-[100px]">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-sm text-gray-500">Dalam Proses</p>
              <p className="text-2xl font-bold">{stats.inProgress}</p>
            </div>
            <Clock className="w-8 h-8 text-blue-500" />
          </div>
        </div>
      </Card>
      <Card className="border-l-4 border-l-emerald-500">
        <div className="p-4 flex items-center h-full min-h-[100px]">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-sm text-gray-500">Selesai</p>
              <p className="text-2xl font-bold">{stats.completed}</p>
            </div>
            <CheckCircle className="w-8 h-8 text-emerald-500" />
          </div>
        </div>
      </Card>
    </div>
  );
}
